require('./index.css');
var locale = require('./i18n');

Enhancer.registerWidget({
    construct: function(profile, zContext) {
        var that = this;

        var $container = that.getContainer();
        $container.append($('<style>').text(profile.style));
        $container.append($(profile.view));
        try {
            that.controller = eval('(function(){' + profile.controller + '})(Enhancer)') || {};
            that.controller.trig = function() {
                that.trig.apply(that, arguments);
            };
        } catch (e) {
            Enhancer.ZMessage.alert('Your custom window controller has syntax error:'
                + e.message);
            console.error(e);
            return;
        }
        if (typeof that.controller.init === 'function') {
            that.controller.init.apply(that, [zContext]);
        }
        that.trig('complete');

        return $container;
    },
    getData: function() {
        return typeof this.controller.getData === 'function'
            ? this.controller.getData.apply(this)
            : {}
    },
    isReady: function() {
        
        return typeof this.controller.isReady === 'function'
            ? this.controller.isReady.apply(this)
            : true;
    },
    /**
     * [affected description]
     * @param  {[type]} zContext [description]
     * @return {[type]}          [description]
     */
    affected: function(zContext) {
        return typeof this.controller.affected === 'function'
            ? this.controller.affected.apply(this, [zContext])
            : true
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/